import React, { useMemo } from 'react'
import { Global, css } from '@emotion/react'
import clsx from 'clsx'
import { defaultsDeep, get } from 'lodash-es'
import { getUUID } from '@ow/utils'
import { MantineProvider } from '@mantine/core'
import { NotificationsProvider } from '@mantine/notifications'
import {
  defaultTheme,
  _defaultTheme,
  genColors,
  genCompsVars,
  genPalettes,
  transColorToVar,
  genFontColors,
  genFontWeights,
  genFontSize,
  ThemeProvider,
} from '@ow/theme'

const Content = function ({ theme, children }) {
  const finalTheme = useMemo(() => defaultsDeep(theme, defaultTheme), [theme])
  const _finalTheme = useMemo(() => defaultsDeep(theme, _defaultTheme), [theme])
  const className = useMemo(() => `ow-theme-${getUUID()}`, [theme])

  return (
    <>
      <Global
        styles={css`
          body {
            .${className} {
              ${genColors({ theme: finalTheme })};
              ${genPalettes(get(finalTheme, 'palettes'))};
              ${genCompsVars('button', get(finalTheme, 'button'))};
              ${genCompsVars('box', get(finalTheme, 'box'))};
              ${genCompsVars('shadow', get(finalTheme, 'shadow'))};
              ${transColorToVar(get(_finalTheme, 'colors'))};
              ${transColorToVar(get(_finalTheme, 'fontColors'))};
              ${genFontColors(get(_finalTheme, 'fontColors'))};
              ${genFontWeights(get(_finalTheme, 'fontWeights'))};
              ${genFontSize(get(_finalTheme, 'fontSizes'))}
            }
          }
          .dark {
            .${className} {
              ${genPalettes(get(finalTheme, 'palettesDark'))};
              .dark\\:bg-map {
                background-color: var(--ow-bg-map-color);
              }
            }
          }
        `}
      />
      <div className={clsx(className, 'flex-1 flex w-full')}>
        <ThemeProvider value={{ theme, themeClass: className }}>
          <MantineProvider
            withNormalizeCSS
            withGlobalStyles
            theme={{
              colors: {
                primary: Object.values(get(_finalTheme, ['colors', 'primary'])),
              },
              primaryColor: 'primary',
            }}
          >
            <NotificationsProvider>{children}</NotificationsProvider>
          </MantineProvider>
        </ThemeProvider>
      </div>
    </>
  )
}
export default Content
